export const MAX_LEN = 100;
export const MAX_RANGE = 100;
export const MIN_RANGE = 5;
